import { ModalService } from '@capsicum/common-web';
import { useV2FTMigrationAnalytics, type V2FTMigrationScreenProps } from '@capsicum/features/nc-wallet/shared';
import { useEffect } from 'react';

import { V2FTMigrationModalContent } from './V2FTMigrationModalContent';
import { V2FTMigrationModalFooter } from './V2FTMigrationModalFooter';

export const V2FTMigrationUpgradeModalScreen = ({ changeScreen, tokens }: V2FTMigrationScreenProps) => {
	const { triggerModalUpgradeFTMigrationEvent } = useV2FTMigrationAnalytics({ tokens });

	useEffect(() => {
		if (tokens.length === 0) return;

		triggerModalUpgradeFTMigrationEvent();

		const modalID = ModalService.addModal({
			isClosable: false,
			renderComponent: () => <V2FTMigrationModalContent tokens={tokens} />,
			renderFooter: () => <V2FTMigrationModalFooter changeScreen={changeScreen} tokens={tokens} />
		});

		return () => {
			ModalService.removeModal(modalID);
		};
	}, [changeScreen, tokens, triggerModalUpgradeFTMigrationEvent]);

	return null;
};
